// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar__button--jwtv__dot[data-v-0fec8c88]{display:inline-block;width:6px;height:6px;background:#e5001a;border-radius:50%;margin-inline-start:4px;flex-shrink:0;align-self:center}.navbar__button__link__item--jwtv[data-v-0fec8c88]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
